<template>
  <a-row :gutter="16" justify="space-around" align="middle" class="contact-channels">
    <a-col :span="8">
      <div class="contact-item">
        <a-icon type="wechat" :style="{ fontSize: '32px' }" />
        <div class="contact-item-content">
          <img src="../../layouts/Navbar/wechat_qrcode.png"  alt="WeChat QRCode" width="160" />
        </div>
      </div>
    </a-col>
    <a-col :span="8">
      <div class="contact-item">
        <a-icon type="github" :style="{ fontSize: '32px' }" />
        <div class="contact-item-content">
          <p style="font-size: 22px; padding-left: 12px;padding-right: 12px;white-space: pre-line;">
            {{$t('scope.tech_support.github.segs_0')}}
            <a-button type="link" style="font-size: 22px;padding: 0;" @click="open(issue_create_url)">{{ $t('common.workflow.submit') }}</a-button>
            {{$t('scope.tech_support.github.segs_1')}}
            <a-button type="link" style="font-size: 22px;;padding: 0;" @click="open(issue_list_url)">{{ $t('scope.tech_support.github.search') }}</a-button>
            {{$t('scope.tech_support.github.segs_2')}}
          </p>
        </div>
      </div>
    </a-col>
    <a-col :span="8" v-if="companyInfo && companyInfo.hotline">
      <div class="contact-item">
        <a-icon type="phone" :style="{ fontSize: '32px' }" />
        <div class="contact-item-content">
          <a-tooltip :title="$t('navbar.text.hotline')">
            <a-button type="dashed" style="font-size: 22px;" shape="round" icon="phone">{{ companyInfo.hotline }}</a-button>
          </a-tooltip>
        </div>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import { mapState } from 'vuex'

// todo: 是否需要增加优先推荐途径的标签？
export default {
  name: 'TechSupport',
  data () {
    return {
      issue_create_url: 'https://github.com/yunionio/cloudpods/issues/new/choose',
      issue_list_url: 'https://github.com/yunionio/cloudpods/issues?q=',
    }
  },
  computed: {
    ...mapState('app', {
      companyInfo: state => state.companyInfo,
    }),
  },
  methods: {
    open (url) {
      window.open(url, '_blank')
    },
  },
}
</script>

<style lang="less" scoped>
.contact-channels {
  .contact-item {
    text-align: center;
    padding-top: 12px;
    padding-bottom: 12px;
    &:hover {
      background-color: rgba(33, 83, 211, 0.09);
    }

    .contact-item-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      min-height: 160px;
    }
  }
}
</style>
